import React from 'react';
import MobileMenu from './mainJS/mobile-menu';
import PcMenu from './mainJS/pcMenu';
import { createRoot } from 'react-dom/client';
//import ReactDOM from "react-dom";

export default function App() {
  return (
    <div>
    </div>
  );
}

function mobileMenu() {
  //Menu data downloads
  const mobileRoot = createRoot(document.getElementById('menu-line'));
  setTimeout(function () {
    /*ReactDOM.render(
      <MobileMenu />,
      document.getElementById("menu-line")
    );*/
    mobileRoot.render(<MobileMenu />);
  }, 10);
}

function pcMenu() {
  //Menu data downloads
  const pcRoot = createRoot(document.getElementById('shop'));
  setTimeout(function () {
    pcRoot.render(<PcMenu />);
  }, 800);
}

mobileMenu();

pcMenu();